(() => {
  const activeCurrency = String(window.Shopify?.currency?.active || 'USD').toUpperCase();
  const rate = Number(window.Shopify?.currency?.rate);
  if (activeCurrency === 'USD' || !Number.isFinite(rate) || rate <= 0) return;

  const locale = document.documentElement.lang || undefined;
  const dollarCurrencies = new Set(['AUD', 'CAD', 'NZD', 'SGD']);
  const skipTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'TEXTAREA', 'PRE', 'CODE']);
  const commerceMoneySelector = [
    '.price',
    '.money',
    '[class*="price"]',
    '[data-price]',
    '[data-cart-item-price]',
    '.totals',
    '.cart-item__totals',
    'shopify-payment-terms'
  ].join(',');
  const hardcodedAmountPattern = /\$\s*2(?:,|\s)?000|2(?:,|\s)?000\s*\$/g;
  const shippingAmountPattern = /\$\s*35|35\s*\$|35\s*(?:USD|dollars?|دولار(?:ًا)?|דולר(?:ים)?|ドル)/gi;
  const staticDollarAmountPattern = /\$\s*(\d[\d,]*(?:\.\d+)?)|(\d[\d,]*(?:\.\d+)?)\s*\$/g;

  const formatConverted = (usdAmount) => {
    const converted = usdAmount * rate;
    try {
      if (dollarCurrencies.has(activeCurrency)) {
        const number = new Intl.NumberFormat(locale, {
          maximumFractionDigits: 2
        }).format(converted);
        return `${activeCurrency} ${number}`;
      }
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency,
        maximumFractionDigits: activeCurrency === 'JPY' ? 0 : 2
      }).format(converted);
    } catch (_error) {
      return `${activeCurrency} ${activeCurrency === 'JPY' ? Math.round(converted) : converted.toFixed(2)}`;
    }
  };

  const replaceInTextNode = (node, pattern, amount) => {
    if (!node?.nodeValue || !pattern.test(node.nodeValue)) return;
    pattern.lastIndex = 0;
    node.nodeValue = node.nodeValue.replace(pattern, formatConverted(amount));
  };

  const walkTextNodes = (root, callback) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || skipTags.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return node.nodeValue?.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    let node;
    while ((node = walker.nextNode())) callback(node);
  };

  const patchStaticDollarAmounts = (root = document.body) => {
    walkTextNodes(root, (node) => {
      if (node.parentElement?.closest(commerceMoneySelector)) return;
      if (!staticDollarAmountPattern.test(node.nodeValue)) {
        staticDollarAmountPattern.lastIndex = 0;
        return;
      }
      staticDollarAmountPattern.lastIndex = 0;
      node.nodeValue = node.nodeValue.replace(
        staticDollarAmountPattern,
        (match, prefixedAmount, suffixedAmount) => {
          const rawAmount = String(prefixedAmount || suffixedAmount || '').replace(/,/g, '');
          const usdAmount = Number(rawAmount);
          return Number.isFinite(usdAmount) ? formatConverted(usdAmount) : match;
        }
      );
    });
  };

  const patchHardcodedClaims = (root = document.body) => {
    walkTextNodes(root, (node) => replaceInTextNode(node, hardcodedAmountPattern, 2000));

    document.querySelectorAll(
      '[id*="rich_text_Rx7hCh"], [id*="icon_bar_i3eUQ6"], .announcement-bar'
    ).forEach((container) => {
      walkTextNodes(container, (node) => replaceInTextNode(node, shippingAmountPattern, 35));
    });

    patchStaticDollarAmounts(root);
  };

  const addCurrencyCodes = (root = document) => {
    if (!dollarCurrencies.has(activeCurrency)) return;
    const selector = commerceMoneySelector;
    const containers = [
      ...(root.matches?.(selector) ? [root] : []),
      ...(root.querySelectorAll?.(selector) || [])
    ];
    containers.forEach((container) => {
      walkTextNodes(container, (node) => {
        if (!/\$\s*\d/.test(node.nodeValue) || new RegExp(`\\b${activeCurrency}\\b`).test(node.nodeValue)) return;
        node.nodeValue = node.nodeValue.replace(/\$\s*(?=\d)/g, `${activeCurrency} $`);
      });
    });
  };

  const patch = (root = document) => {
    patchHardcodedClaims(root === document ? document.body : root);
    addCurrencyCodes(root);
  };

  patch(document);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) patch(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => patch(event.target || document));
  document.addEventListener('cart:updated', () => patch(document));
})();
